// extracted by mini-css-extract-plugin
export var linkText = "_o8-0";